export const prnToScatterId = (id: string): string => {
  const isStrongId = !id.includes(":")
  return isStrongId ? id : id.split(":").slice(-1)[0]
}

type NonOptionalString<T> = T extends string ? T : never

export const buildPrn = <T extends { __typename?: string }>(
  modelName: NonOptionalString<T["__typename"]>,
  id: string | undefined
): string => {
  if (!id) return ""
  return `${modelName}:${prnToScatterId(id)}`
}
